var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconFolder = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.9231 6.8304H12.3878L9.76348 3.27444C9.63762 3.10394 9.41405 3 9.17308 3H2.07692C0.931708 3 0 3.77312 0 4.7234V19.2766C0 20.2269 0.931708 21 2.07692 21H21.9231C23.0683 21 24 20.2269 24 19.2766V8.5538C24 7.60348 23.0683 6.8304 21.9231 6.8304Z",
  fill: "#4253A9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.4267 13.1533C10.8949 13.1533 10.363 13.3213 9.95816 13.6573C9.14839 14.3293 9.14839 15.4226 9.95816 16.0946C10.768 16.7665 12.0857 16.7665 12.8954 16.0946C13.7052 15.4226 13.7052 14.3293 12.8954 13.6573C12.4905 13.3213 11.9586 13.1533 11.4267 13.1533Z",
  fill: "#4253A9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.9227 5.68211V5.49001C21.9227 4.53972 20.991 3.7666 19.8458 3.7666H11.7495L13.1632 5.68211H21.9227Z",
  fill: "#4253A9"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFolder, _extends({
  svgRef: ref
}, props)));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik0yMS45MjMxIDYuODMwNEgxMi4zODc4TDkuNzYzNDggMy4yNzQ0NEM5LjYzNzYyIDMuMTAzOTQgOS40MTQwNSAzIDkuMTczMDggM0gyLjA3NjkyQzAuOTMxNzA4IDMgMCAzLjc3MzEyIDAgNC43MjM0VjE5LjI3NjZDMCAyMC4yMjY5IDAuOTMxNzA4IDIxIDIuMDc2OTIgMjFIMjEuOTIzMUMyMy4wNjgzIDIxIDI0IDIwLjIyNjkgMjQgMTkuMjc2NlY4LjU1MzhDMjQgNy42MDM0OCAyMy4wNjgzIDYuODMwNCAyMS45MjMxIDYuODMwNFoiIGZpbGw9IiM0MjUzQTkiLz4KPHBhdGggZD0iTTExLjQyNjcgMTMuMTUzM0MxMC44OTQ5IDEzLjE1MzMgMTAuMzYzIDEzLjMyMTMgOS45NTgxNiAxMy42NTczQzkuMTQ4MzkgMTQuMzI5MyA5LjE0ODM5IDE1LjQyMjYgOS45NTgxNiAxNi4wOTQ2QzEwLjc2OCAxNi43NjY1IDEyLjA4NTcgMTYuNzY2NSAxMi44OTU0IDE2LjA5NDZDMTMuNzA1MiAxNS40MjI2IDEzLjcwNTIgMTQuMzI5MyAxMi44OTU0IDEzLjY1NzNDMTIuNDkwNSAxMy4zMjEzIDExLjk1ODYgMTMuMTUzMyAxMS40MjY3IDEzLjE1MzNaIiBmaWxsPSIjNDI1M0E5Ii8+CjxwYXRoIGQ9Ik0yMS45MjI3IDUuNjgyMTFWNS40OTAwMUMyMS45MjI3IDQuNTM5NzIgMjAuOTkxIDMuNzY2NiAxOS44NDU4IDMuNzY2NkgxMS43NDk1TDEzLjE2MzIgNS42ODIxMUgyMS45MjI3WiIgZmlsbD0iIzQyNTNBOSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };